import React, { useEffect, useState } from 'react';
import './_MultiFactor.scss';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { ShowToast } from '../../common/Toastr';
import fetchAPI from '../../common/fetchAPI';
import { getValueFromResource } from '../../common/timeLiveFunction';
import { t } from 'i18next';
import { KTSVG } from '../../_metronic/helpers';

const MultiFactorModal = ({ isOpen, onClose, children, closeOnOverlayClick = true }: any) => {
    const dispatch = useAppDispatch();
    const { sessionAccountEmployeeId, timeZoneId, emailAddress: sessionemailAddress, sessionAccountId } = useAppSelector((state) => state.globalState);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [isMFAAuthenticationList, setIsMFAAuthenticationList] = useState(true);
    const [isAddAuthentication, setIsAddAuthentication] = useState(false);
    const [isAuthenticatorApplicationAuthentication, setIsAuthenticatorApplicationAuthentication] = useState(false);
    const [isAuthenticatorApplicationAuthenticationQRCode, setIsAuthenticatorApplicationAuthenticationQRCode] = useState(false);
    const [isEmailAuthentication, setIsEmailAuthentication] = useState(false);
    const [emailAddress, setEmailAddress] = useState<any>(sessionemailAddress);
    const [enableMultiFactorAuthentication, setEnableMultiFactorAuthentication] = useState(false);
    const [multiFactorAuthenticationList, setMultiFactorAuthenticationList] = useState<any>([]);
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [manualEntryKey, setManualEntryKey] = useState('');
    const [accountSecretKey, setAccountSecretKey] = useState('');
    const [code, setCode] = useState('');
    const [isManualEntryKeyText, setIsManualEntryKeyText] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
        getFillMFARecords();
    }, [])

    const getFillMFARecords = async () => {
        const response = await fetchAPI("api/MultiFactorAuth", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        if (JSON.parse(json)[0].AccountEmployeeMFAId) {
            setMultiFactorAuthenticationList(JSON.parse(json));
        }
        else {
            setMultiFactorAuthenticationList([]);
        }
        setEnableMultiFactorAuthentication(JSON.parse(json)[0].EnableMultiFactorAuthentication);
        setEmailAddress(localStorage.getItem('userEmailAddress'));

    }
    const handleEnableMultiFactorAuthenticationChange = async (event: any) => {
        setEnableMultiFactorAuthentication(event.target.checked);
        const requestData = {
            AccountEmployeeId: sessionAccountEmployeeId,
            EnableMultiFactorAuthentication: event.target.checked
        };
        const response = await fetchAPI("api/Employees/UpdateEnableMultiFactorAuthentication", "POST", requestData, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        ShowToast(json, 'Success', "success", "toast-top-right");
    }

    const handleResendEmail = async (obj: any) => {
        const emailUrl = `${window.origin}/`;  // Base URL of your app

        // Prepare the data to send in the request body
        const requestBody = {
            accountEmployeeMFAId: obj.AccountEmployeeMFAId,
            timeZoneId: timeZoneId,
            emailUrl: `${window.origin}/`
        };

        //const response = await fetchAPI("api/MultiFactorAuth/SendVerificationEmail/" + obj.AccountEmployeeMFAId + "/" + timeZoneId, "POST", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");

        const response = await fetchAPI(`api/V2/MultiFactorAuth/SendVerificationEmail`, "POST", requestBody, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        ShowToast("Verification Email Sent!", "A verification email has been sent to " + obj.AccountTitle, "success", "toast-top-right");
    }

    const handleDelete = async (AccountEmployeeMFAId: any) => {
        const response = await fetchAPI("api/MultiFactorAuth/" + AccountEmployeeMFAId, "Delete", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = response.json();
        ShowToast(json, 'Success', "success", "toast-top-right");
        getFillMFARecords();
    }

    const validateEmailAddress = (email: any) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const addRecordAfterValidate = async (AccountTitle: any, AccountSecretKey: any, SystemMultiFactorAuthenticationTypeId: any, ManualEntryKey: any) => {

        const requestData = {
            accountId: sessionAccountId,
            accountEmployeeId: sessionAccountEmployeeId,
            accountTitle: AccountTitle,
            accountSecretKey: AccountSecretKey,
            systemMultiFactorAuthenticationTypeId: SystemMultiFactorAuthenticationTypeId,
            manualEntryKey: ManualEntryKey,
            timeZoneId: timeZoneId,
            emailUrl: `${window.origin}/`
        };
        const response = await fetchAPI("api/V2/MultiFactorAuth/", "POST", requestData, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        if (typeof json === 'string' && json.includes("already exists")) {
            ShowToast('Warning', json, "warning", "toast-top-right");
        }
        else {
            if (SystemMultiFactorAuthenticationTypeId == 1) {
                ShowToast('Authenticator Application Configured!', "Authentication codes from the registered Authenticator Application can now be used to login.", "success", "toast-top-right");
            } else {
                ShowToast("Verification Email Sent!", "A verification email has been sent to " + AccountTitle, "success", "toast-top-right");
            }

            getFillMFARecords();
            setIsMFAAuthenticationList(true);
            setIsAddAuthentication(false);
            setIsAuthenticatorApplicationAuthentication(false);
            setIsAuthenticatorApplicationAuthenticationQRCode(false);
            setIsEmailAuthentication(false);
            setEnableMultiFactorAuthentication(false);
            setIsManualEntryKeyText(false);

        }


    }

    const generateQrCode = async () => {
        const response = await fetchAPI("api/MultiFactorAuth/Generate?Issuer=TimeLive&AccountTitle=" + emailAddress, "POST", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        if (json && json.Account) {
            setIsAuthenticatorApplicationAuthenticationQRCode(true);
            setIsAuthenticatorApplicationAuthentication(false);
            setQrCodeUrl(json.QrCodeSetupImageUrl);
            setAccountSecretKey(json.accountSecretKey);
            setManualEntryKey(json.ManualEntryKey);
            setCode('');
        }
        else {
            ShowToast('Warning', json, "warning", "toast-top-right");
        }
    }

    const addAuthenticationApp = async () => {
        const response = await fetchAPI("api/MultiFactorAuth/Validate/" + accountSecretKey + "/" + code, "POST", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        if (json) {
            addRecordAfterValidate(emailAddress, accountSecretKey, 1, manualEntryKey);
            setIsAuthenticatorApplicationAuthenticationQRCode(true);
            setIsAuthenticatorApplicationAuthentication(false);
        }
        else {
            ShowToast('Verification Failed!', "The code you entered is invalid. Please enter the correct code.", "error", "toast-top-right");
        }
    }
    const handleCodeInputChange = (e: any) => {
        const newCode = e.target.value;

        // Set the code value and enable/disable the button based on length
        setCode(newCode);
        if (newCode.length === 6) {
            setIsButtonDisabled(false); // Enable the button if the code length is 6
        } else {
            setIsButtonDisabled(true); // Disable the button if the code length is not 6
        }
    };

    useEffect(() => {
        const handleEscape = (e: any) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.body.classList.add('multifactorOpen');
            document.documentElement.style.setProperty('--sidebar-z-index', 'auto');
            document.addEventListener('keydown', handleEscape);
        } else {
            document.body.classList.remove('multifactorOpen');
            document.documentElement.style.removeProperty('--sidebar-z-index');
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.classList.remove('multifactorOpen');
            document.documentElement.style.removeProperty('--sidebar-z-index');
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="modal-container">
            <div
                className="modal-overlay"
                onClick={closeOnOverlayClick ? onClose : null}
            />

            <div className="multifactor-content">
                <div className="modal-header-part" >
                    <h5 className="modal-title mainHeading">
                        {/* Security */}
                        {getValueFromResource('Security', dispatch, t)}

                    </h5>
                    <div
                        className="btn btn-icon btn-sm btn-active-secondary ms-2"
                        onClick={onClose}
                    >
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-1x"
                        />
                    </div>
                </div>
                <div className="modal-body">
                    <form className='form'>
                        {isMFAAuthenticationList &&
                            <>
                                <div className="mb-3">
                                    <span className="card-title fw-bold headerTitle">
                                        {/* Multi-Factor Authentication */}
                                        {getValueFromResource('Multi-Factor Authentication', dispatch, t)}
                                    </span>
                                    <p className=" d-block" >
                                        {/* Add an extra layer of security in case the password is stolen or compromised. */}
                                        {getValueFromResource('Add an extra layer of security in case the password is stolen or compromised.', dispatch, t)}
                                    </p>
                                </div>
                                <div className='separator mb-3'></div>
                                <div className="mb-3">
                                    <label className="fs-7 fw-normal  d-block">
                                        {/* Enable Multi-Factor Authentication */}
                                        {getValueFromResource('Enable Multi-Factor Authentication', dispatch, t)}
                                    </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input className="form-check-input h-20px w-30px mb-2" type="checkbox"
                                            checked={enableMultiFactorAuthentication}
                                            id="EnableMultiFactorAuthentication"
                                            onChange={(event) => handleEnableMultiFactorAuthenticationChange(event)}
                                        />
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                                        <thead>
                                            <tr className="thHeading align-middle "  >
                                                <th className="col">
                                                    {/* Email */}
                                                    {getValueFromResource('Email', dispatch, t)}
                                                </th>
                                                <th className="col" >
                                                    {/* Type */}
                                                    {getValueFromResource('Type', dispatch, t)}
                                                </th>
                                                <th className="col">
                                                    {/* Action */}
                                                    {getValueFromResource('Action', dispatch, t)}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {multiFactorAuthenticationList && multiFactorAuthenticationList.length > 0 && multiFactorAuthenticationList.map((multiFactorAuthenticationListObject: any, i: any) => (
                                                <tr key={i}>
                                                    <td className='text-gray-800  text-hover-primary custom-pointer-cursor '>
                                                        <span className="   d-block "
                                                        >{multiFactorAuthenticationListObject.AccountTitle}</span>
                                                    </td>
                                                    <td className='text-center'>
                                                        {multiFactorAuthenticationListObject.SystemMultiFactorAuthenticationTypeId == 2 ?
                                                            <>
                                                                {multiFactorAuthenticationListObject.IsEmailVerified ?
                                                                    <td className="mfaStatusImage">
                                                                        <i className="bi bi-check-circle  font-size-16" title="Enabled" style={{ color: 'green' }}></i>
                                                                    </td>
                                                                    :
                                                                    <td className="mfaStatusImage">
                                                                        <i className="bi bi-clock  font-size-16" title="Waiting Verification" style={{ color: '#c29d0b' }}></i>
                                                                    </td>
                                                                }
                                                                <td className="mfaStatus ">
                                                                    {/* Email */}
                                                                    {getValueFromResource('Email', dispatch, t)}
                                                                </td>
                                                                {!multiFactorAuthenticationListObject.IsEmailVerified &&
                                                                    <td className="mfaAction"><a
                                                                        className="reSendEmail"
                                                                        data-id={multiFactorAuthenticationListObject.AccountEmployeeMFAId}
                                                                        data-email={multiFactorAuthenticationListObject.AccountTitle}
                                                                        onClick={(e: any) => {
                                                                            handleResendEmail(multiFactorAuthenticationListObject)
                                                                        }}
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        {/* Resend Verification Email */}
                                                                        {getValueFromResource('Resend Verification Email', dispatch, t)}
                                                                    </a></td>
                                                                }
                                                                <td className="mfaDelete delete_button" title="Delete" data-id={multiFactorAuthenticationListObject.AccountEmployeeMFAId}>
                                                                    <a id="btnMfaDelete"></a>
                                                                </td>
                                                            </>
                                                            :
                                                            <>
                                                                <td className="mfaStatusImage">
                                                                    <i className="bi bi-check-circle font-size-16" title="Enabled" style={{ color: 'green' }}></i>
                                                                </td>
                                                                <td className="mfaStatus ">
                                                                    {/* TOTP */}
                                                                    {getValueFromResource('TOTP', dispatch, t)}
                                                                </td>
                                                                <td className="mfaAction"></td>
                                                                <td className="mfaDelete delete_button" title="Delete" data-id={multiFactorAuthenticationListObject.AccountEmployeeMFAId}>
                                                                    <a id="btnMfaDelete"></a>
                                                                </td>
                                                            </>

                                                        }
                                                    </td>
                                                    <td className='text-center'>
                                                        <button
                                                            onClick={(e: any) => {
                                                                e.preventDefault();
                                                                handleDelete(multiFactorAuthenticationListObject.AccountEmployeeMFAId)
                                                            }
                                                            }
                                                            className="btn btn-link p-0"
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                            onMouseEnter={() => setHoveredIndex(i)}
                                                            onMouseLeave={() => setHoveredIndex(null)}
                                                        >
                                                            <i
                                                                className="bi bi-trash fs-5"
                                                                style={{
                                                                    color: hoveredIndex === i ? 'red' : 'black',
                                                                    transition: 'color 0.3s ease'
                                                                }}
                                                            ></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mb-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                        onClick={() => {
                                            setIsAddAuthentication(true);
                                            setIsMFAAuthenticationList(false);
                                        }}
                                    >
                                        {/* Add Authentication Method */}
                                        {getValueFromResource('Add Authentication Method', dispatch, t)}
                                    </button>
                                </div>
                            </>
                        }
                        {isAddAuthentication &&
                            <>
                                <div className="mb-3">
                                    <div className="row mb-3 " >
                                        <i className="ki-outline bi bi-arrow-left-circle fs-3 text-primary me-2" onClick={() => { setIsAddAuthentication(false); setIsMFAAuthenticationList(true); }} style={{
                                            cursor: 'pointer'
                                        }}>

                                        </i>
                                        <span className="card-title fw-bold headerTitle text-center">
                                            {/* Add Authentication Method */}
                                            {getValueFromResource('Add Authentication Method', dispatch, t)}
                                        </span>
                                        <p className=" d-block text-center" >
                                            {/* Add an extra layer of security in case the password is stolen or compromised. */}
                                            {getValueFromResource('Add an extra layer of security in case the password is stolen or compromised.', dispatch, t)}
                                        </p>
                                    </div>

                                    <div className='separator mb-3'></div>


                                    <div className="row mb-3"
                                        onClick={() => { setIsEmailAuthentication(true); setIsAddAuthentication(false); setIsAuthenticatorApplicationAuthentication(false); }}
                                        style={{
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <div className="col-md-12">
                                            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed flex-shrink-0 p-2 align-items-center">
                                                <i className="ki-outline bi bi-envelope fs-3 text-primary me-2">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                                <div className="d-flex flex-column flex-grow-1">
                                                    <div className="mb-3 mb-md-0 fw-semibold">
                                                        <h4 className="text-gray-700 fw-bold fs-3">
                                                            {/* Email */}
                                                            {getValueFromResource('Email', dispatch, t)}
                                                        </h4>
                                                        <div className="fs-7 text-gray-600 pe-7">
                                                            {/* Verification codes sent by email. */}
                                                            {getValueFromResource('Verification codes sent by email.', dispatch, t)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row"
                                        onClick={() => { setIsAuthenticatorApplicationAuthentication(true); setIsAddAuthentication(false); setIsEmailAuthentication(false); }}
                                        style={{
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <div className="col-md-12">
                                            <div className="notice d-flex bg-light-primary rounded border-primary border border-dashed flex-shrink-0 p-2 align-items-center">
                                                <i className="ki-outline bi bi-shield-shaded fs-3 text-primary me-2">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                                <div className="d-flex flex-column flex-grow-1">
                                                    <div className="mb-3 mb-md-0 fw-semibold">
                                                        <h4 className="text-gray-700 fw-bold fs-3" >
                                                            {/* Authenticator Application (TOTP) */}
                                                            {getValueFromResource('Authenticator Application (TOTP)', dispatch, t)}
                                                        </h4>
                                                        <div className="fs-7 text-gray-600 pe-7">
                                                            {/* Use a TOTP Authenticator app to get verification codes. */}
                                                            {getValueFromResource('Use a TOTP Authenticator app to get verification codes', dispatch, t)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>}

                        {(isEmailAuthentication || isAuthenticatorApplicationAuthentication) &&
                            <>
                                <div className="mb-3">
                                    <div className="row mb-3 " >
                                        <i className="ki-outline bi bi-arrow-left-circle fs-3 text-primary me-2" onClick={() => { setIsEmailAuthentication(false); setIsAddAuthentication(true); setIsAuthenticatorApplicationAuthentication(false); }} style={{
                                            cursor: 'pointer'
                                        }}></i>
                                        <span className="card-title fw-bold headerTitle text-center">{isEmailAuthentication ? getValueFromResource('Email', dispatch, t) : getValueFromResource('Authenticator Application (TOTP)', dispatch, t)} </span>
                                        <p className=" d-block text-center" >{isEmailAuthentication ? getValueFromResource('Verification codes send by email', dispatch, t) : getValueFromResource('Use a TOTP Authenticator app to get verification codes', dispatch, t)}</p>
                                    </div>
                                    <div className='separator mb-3'></div>
                                    <div className="mb-3">
                                        <label className="fs-7 fw-normal d-block mb-2">
                                            {/* Account Name */}
                                            {getValueFromResource('Account Name', dispatch, t)}
                                        </label>
                                        <input type="text"
                                            className="form-control fs-7 fw-normal mb-2"
                                            id='AccountName'
                                            value={emailAddress}
                                            name='AccountName'
                                            onChange={(e: any) => setEmailAddress(e.target.value)}
                                        />
                                    </div>
                                </div>

                            </>
                        }
                        {isAuthenticatorApplicationAuthenticationQRCode &&
                            <>
                                <div className="mb-3">
                                    <div className="row mb-3">
                                        <i className="ki-outline bi bi-arrow-left-circle fs-3 text-primary me-2" onClick={() => { setIsAuthenticatorApplicationAuthenticationQRCode(false); setIsAuthenticatorApplicationAuthentication(true); }} style={{ cursor: 'pointer' }}></i>
                                        <div className="row w-100">
                                            <div className="col-md-12 d-flex align-items-center ">
                                                <span className="card-title fw-bold headerTitle" style={{ marginRight: '5px' }}>
                                                    {/* Account Name :  */}
                                                    {getValueFromResource('Account Name', dispatch, t)}
                                                </span>
                                                <span className="d-block text-start">{emailAddress}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='separator mb-3'></div>
                                    <div className="mb-3">
                                        <label className="fs-7 fw-normal  d-block">
                                            {/* Scan this QR code with your authenticator application: */}
                                            {getValueFromResource('Scan this QR code with your authenticator application', dispatch, t)}
                                        </label>
                                        <div className="text-center">
                                            <img id="imgQrCode" src={qrCodeUrl} alt="QR Code" />
                                        </div>
                                        <div className="mb-3 text-center">
                                            <a id="spanManualEntryText" onClick={() => setIsManualEntryKeyText(true)} style={{ display: `${isManualEntryKeyText ? 'none' : 'block'}`, cursor: 'pointer' }}>
                                                {/* Can't scan the QR code? */}
                                                {getValueFromResource("Can't scan the QR code?", dispatch, t)}
                                            </a>
                                            <span className="display-none" id="spanManualEntryKeyText" style={{ display: `${isManualEntryKeyText ? 'block' : 'none'}` }}>
                                                {/* Using secret key: */}
                                                {getValueFromResource('Using secret key:', dispatch, t)}
                                                <strong id="spanManualEntryKey">{manualEntryKey}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="fs-7 fw-normal  d-block">
                                            {/* Enter the six-digit code from the application: */}
                                            {getValueFromResource('Enter the six-digit code from the application', dispatch, t)}
                                        </label>
                                        <input type="text"
                                            className="form-control fs-7 fw-normal mb-2"
                                            id='code'
                                            value={code}
                                            name='code'
                                            onChange={(e: any) => handleCodeInputChange(e)}
                                            style={{ width: '100px' }}
                                        />
                                    </div>
                                </div>

                            </>
                        }
                        <div className="mb-3">

                        </div>

                    </form>
                </div>

                <div className="modal-footer footerLine" style={{ padding: '.6rem .6rem' }} >
                    {(isEmailAuthentication || isAuthenticatorApplicationAuthentication) &&
                        <button
                            type="button"
                            className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                            onClick={(e: any) => {
                                e.preventDefault();
                                let methodType: string = "EMAIL";
                                if (isEmailAuthentication) {
                                    if (validateEmailAddress(emailAddress)) {
                                        addRecordAfterValidate(emailAddress, Math.floor(100000 + Math.random() * 900000), 2, '');
                                    }
                                    else {
                                        ShowToast("Validation Failed!", "Please enter a valid email address", "error", "toast-top-right");
                                    }
                                }
                                else {
                                    methodType = "TOTP";
                                    if (emailAddress != "") {
                                        generateQrCode();

                                    }
                                }
                            }}
                        >
                            {/* Next */}
                            {getValueFromResource('Next', dispatch, t)}
                        </button>
                    }
                    {(isAuthenticatorApplicationAuthenticationQRCode) &&
                        <button
                            type="button"
                            className="btn btn-primary btn-bs-btn-font-weight btn-sm"
                            onClick={() => {
                                addAuthenticationApp();
                            }}
                            disabled={isButtonDisabled}
                        >
                            {/* Add Authentication Application */}
                            {getValueFromResource('Add Authentication Application', dispatch, t)}
                        </button>
                    }
                    <button
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                        onClick={onClose}
                    >
                        {/* Close */}
                        {getValueFromResource('Cancel', dispatch, t)}
                    </button>
                </div>
                {/* {children} */}
            </div>
        </div>
    );
};

export default MultiFactorModal;